export default {
    computed: {
        goodsFilter() {
            if (!this.fields.provider?.key) return []
            return [
                {
                    _ParentOperator: 'AND',
                    _Operator: 'AND',
                    Fields: {
                        provider: {
                            type: 3,
                            int: parseInt(this.fields.provider.key, 10),
                            opt: '=',
                        },
                    },
                },
            ]
        },
    },
    methods: {
        createConcept() {
            this.fields.concepts.push({
                discount: 0,
                expense: 0,
                good: 0,
                price: 0,
                quantity: 0,
                iva: 0,
                text: '',
            })
        },
        articleChange(article, index) {
            if (article?.data) {
                const sinIva = article.data.price / (1 + article.data.iva / 100)

                const concept = {
                    ...this.fields.concepts[index],
                    name: article.data.name,
                    price: sinIva,
                    iva: article.data.iva,
                    quantity: 1,
                    text: '',
                    discount: 0,
                    good: article.data._EntityId,
                }

                this.$set(this.fields.concepts, index, concept)
            }
        },
        removeConcept(index) {
            this.fields.concepts.splice(index, 1)
        },
    },
}
